import React from 'react';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import { TEST_PROFILES } from '../TestVendorRequestProfiles';
import type { ProfileSelectorProps } from '../../../../../types/testVendorRequest.types';

// Reusable profile selector used by Test POST and other tools
const ProfileSelector: React.FC<ProfileSelectorProps> = ({ selectedProfileId, onChange }) => {
  return (
    <div>
      <FormLabel htmlFor='test-profile-select' sx={{ display: 'block', mb: 0.5 }}>
        Test Profile
      </FormLabel>
      {/* native so the test's `data-testid` still resolves to a <select> it can set a value on */}
      <TextField
        select
        id='test-profile-select'
        value={selectedProfileId}
        onChange={(e) => onChange(e.target.value)}
        slotProps={{ select: { native: true, inputProps: { 'data-testid': 'test-profile-select' } } }}
      >
        {TEST_PROFILES.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </TextField>
    </div>
  );
};

export default ProfileSelector;
